export const sources = {
	webp: "__VITE_ASSET__HAwZnQ40A17rYC3Q$lxt9A__ 500w, __VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__ 682w"
};
export const img = {
	src: "__VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__",
	w: 682,
	h: 500
};
export default {
	sources: sources,
	img: img
};
